import React from 'react';

import List from './List';
import DataGrid from './List/DataGrid';
import TextField from './List/TextField';
import DateField from './List/DateField';
import AuthField from './List/AuthField';

const defaultSort = { field: 'createdAt', order: 'DESC' };

import get from 'lodash/get';

const statusData = {
	resubmission: {
		color: 'green',
		label: 'Erfolgreich eingespielt'
	},
	pending: {
		color: 'red',
		label: 'asd'
	},
};

function StatusField({record, source }) {
	const value = get(record, source);
	const sD = value ? statusData["resubmission"] : statusData["pending"];
	return <span className={`status ${sD.color}`} title={sD.label}></span>;
}

const FailedRequestsList = (props) => {
    return (
        <List {...props} sort={defaultSort} perPage={10}>
            <DataGrid rowClick="show">
                <StatusField source="resubmission.leadId" label="Status" notSearchable />
                <DateField source="createdAt" label="Datum" showTime notSearchable sortable />
                <AuthField source="auth.identifier" label="Auth" />
                <TextField source="endpoint" label="Endpunkt" />
                <TextField source="body.applicant.lastname" label="Kontakt" />
                <TextField source="body.applicant.email" label="E-Mail" />
                <TextField source="resubmission.leadId" label="Lead ID" />
            </DataGrid>
        </List>
    );
};

export default FailedRequestsList;
